import React from 'react';
import { Button } from '@storebrand-digital/pretzel';
import { getText } from '@storebrand-digital/fms-translations';
import styles from './DropdownFilter.module.css';
import { FooterProps } from './types';

const DropdownFilterFooter: React.FC<FooterProps> = ({
  hasSelectedValues,
  isMobile,
  onClear,
  onClose,
}) => {
  const buttonSize = isMobile ? 'medium' : 'small';
  return (
    <div
      className={styles.dropdownContentFooter}
      data-has-count={hasSelectedValues}
    >
      {hasSelectedValues && (
        <div className="buttonContainer">
          {isMobile && (
            <Button size={buttonSize} variant="primary" onClick={onClose}>
              {getText('filter.showResults')}
            </Button>
          )}
          <Button
            size={buttonSize}
            onClick={onClear}
            variant="tertiary"
            iconRight="x"
          >
            {getText('filter.reset')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default DropdownFilterFooter;
